import * as React from "react";

const PageContent = (props: { children: React.ReactNode }) => {
    return <div className="page-content">{props.children}</div>;
};

export default PageContent;
